const platformTypes = {
    '1': 'Social',
    '2': 'Broadcast',
    '3': 'Streaming',
};

export default platformTypes;
